export default "__VITE_ASSET__DT61aHXI__"